import React from 'react';

import { useTranslate } from '@lumapps/translations';

import { NavigationItemModal as Modal } from '.';
import { NAVIGATION_ADMIN } from '../../keys';
import { NavigationItemModal } from '../../types';

export const SystemPageNavigationItemModal: React.FC<NavigationItemModal> = ({
    buttonRef,
    defaultLanguage,
    isEdit = false,
    isOpen = false,
    languages,
    navigationItem,
    navigationItemModalProps = {},
    onClose,
    onSave,
    scope,
}) => {
    const { translateKey } = useTranslate();

    return (
        <Modal
            isOpen={isOpen}
            languages={languages}
            defaultLanguage={defaultLanguage}
            message={translateKey(NAVIGATION_ADMIN.CONTENT_DESCRIPTION)}
            titlePlaceholder={translateKey(NAVIGATION_ADMIN.NAVIGATION_ITEM_TITLE)}
            onSave={onSave}
            buttonRef={buttonRef}
            navigationItem={navigationItem}
            onClose={onClose}
            isEdit={isEdit}
            scope={scope}
            {...navigationItemModalProps}
            displayedFields={{
                ...navigationItemModalProps?.displayedFields,
                url: false,
                openInNewTab: true,
                nodeTitle: true,
            }}
        />
    );
};
